<template>
  <div class="center-outer">

    <div class="statistics-list-outer">
      <StatisticsItem :iconSrc="require('@/assets/images/icon_1.png')" :num="statisData.increment-0" title="村集体增收资金" :unit="(statisData.incrementUnit || '')+'元'"/>
      <StatisticsItem :iconSrc="require('@/assets/images/icon_2.png')" :num="statisData.economy-0" title="村集体节约资金" :unit="(statisData.economyUnit || '')+'元'"/>
      <StatisticsItem :iconSrc="require('@/assets/images/icon_3.png')" :num="statisData.benefit-0" title="效益总额" :unit="(statisData.benefitUnit || '')+'元'"/>
    </div>

    <MiddleMap />

    <div class="bottom-list-outer">
      <BottomItem :bgSrc="require('@/assets/images/bg_分中心.png')"  color="#00FBFF" title="分中心" :num="statisData.centerCnt-0"/>
      <BottomItem :bgSrc="require('@/assets/images/bg_服务站.png')" color="#00B0FF" title="服务站" :num="statisData.siteCnt-0"/>
      <BottomItem :bgSrc="require('@/assets/images/bg_服务点.png')" color="#02E6A9" title="服务点" :num="statisData.pointCnt-0"/>
    </div>

  </div>
</template>

<script>
import StatisticsItem from './StatisticsItem.vue'
import MiddleMap from './MiddleMap.vue'
import BottomItem from './BottomItem.vue'
import {mapGetters} from 'vuex'
export default {
  components:{
    StatisticsItem,
    MiddleMap,
    BottomItem
  },
  data(){
    return {
    }
  },
  computed:{
    ...mapGetters(['statisData'])
  },
  created(){

  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>
.center-outer{
  display: flex;
  flex-direction: column;
}
.statistics-list-outer{
  display: flex;
  justify-content: space-between;
}
.bottom-list-outer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}
</style>